import { render, staticRenderFns } from "./PermissionCollapse.vue?vue&type=template&id=a86502fc&scoped=true&"
import script from "./PermissionCollapse.vue?vue&type=script&lang=js&"
export * from "./PermissionCollapse.vue?vue&type=script&lang=js&"
import style0 from "./PermissionCollapse.vue?vue&type=style&index=0&id=a86502fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86502fc",
  null
  
)

export default component.exports